import AHttpService from '@d-services/a-http-service/a-http-service';
import DropdownOptionsHelper from '@d-helpers/dropdown-options-helper';
import URLS from '@d-shared/urls/urls';

function _decorateStoresList(storesList) {
  storesList.forEach((store) => {
    store.text = `.${ store.text }`;

    switch (store.value) {
      case 'com':
        store.emoji = '🇺🇸';
        break;
      case 'co.uk':
        store.emoji = '🇬🇧';
        break;
      case 'ca':
        store.emoji = '🇨🇦';
        break;
      case 'fr':
        store.emoji = '🇫🇷';
        break;
      case 'es':
        store.emoji = '🇪🇸';
        break;
      case 'de':
        store.emoji = '🇩🇪';
        break;
      case 'it':
        store.emoji = '🇮🇹';
        break;
      default:
        break;
    };
  });

  return storesList;
}

class AmazonStoresService extends AHttpService {
  async getAvailableStores(asOptions = false) {
    const response = await this._http.get(URLS.api.amazon.storesList);

    const stores = response.data.stores;
    if (!asOptions) {
      return stores;
    }

    const storeOptions = DropdownOptionsHelper.getOptionsListFromStrings(stores);
    return _decorateStoresList(storeOptions);
  }

  async getBookAmazonUrl(bookSlug) {
    const url = URLS.api.amazon.bookPurchaseUrl.replace('<book-slug>', bookSlug);
    const response = await this._http.get(url, null);
    return response.data.url;
  }
}

export default new AmazonStoresService();
